<template>
  <v-app>
    <div class="auth-lang">
      <!-- <ListLocale :heading="lang.get('form.lang')" :select="selectedLang"/> -->
    </div>
    <div class="auth-page">
      <router-view :key="$route.fullPath"></router-view>
    </div>

    <notifications :options="{}" />
  </v-app>
</template>

<script>
import ListLocale from '@/components/Shared/ListLocale'

export default {
  components: {
    ListLocale,
  },

  data() {
    return {
      lang: window.lang,
      selectedLang: this.$cookies.get('lang') || 'en',
    }
  },
}
</script>
